import { render, staticRenderFns } from "./pf-ecr.vue?vue&type=template&id=6a88fd3a&"
import script from "./pf-ecr.vue?vue&type=script&lang=js&"
export * from "./pf-ecr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports